export const SEARCH_DRUGS = 'drugs/SEARCH_DRUGS'
export const SEARCH_ALL_DRUGS = 'drugs/SEARCH_ALL_DRUGS'
export const FETCH_DRUG = 'drugs/FETCH_DRUG'
export const RESET_STORE = 'drugs/RESET_STORE'